export const ABOUT_VALUES = [
  { title: "Lượt tiếp cận", number: "56.000+" },
  { title: "Lượt tương tác", number: "7.200+" },
  { title: "Lượt thích", number: "6.300+" },
  { title: "Lượt theo dõi", number: "6.600+" },
];
